export const enum NotificationTypes {
    INFO = "Info",
    DOCK_ASSIGNMENT = "DockAssignment",
    EXIT = "Exit",
}
